import Check from 'lucide-react/dist/esm/icons/check.mjs'
import CircleAlert from 'lucide-react/dist/esm/icons/circle-alert.mjs'

export function ToastViewport({ toasts }) {
  return <div className="toast-viewport" aria-live="polite">{toasts.map(toast => <div className={`app-toast ${toast.tone}`} key={toast.id}>{toast.tone === 'error' || toast.tone === 'warning' ? <CircleAlert size={16}/> : <Check size={16}/>}<span>{toast.message}</span></div>)}</div>
}
